var _style;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      width: 48,
      height: 48,
      opacity: 1
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4B4B4B;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.907,110.129h129.006c15.28,0,27.653-12.382,27.653-27.662v-3.177V57.943v-3.176 c0-15.28-12.373-27.662-27.653-27.662h-34.96C248.555,11.929,235.944,0,220.41,0c-15.55,0-28.162,11.929-29.56,27.105h-34.943 c-15.281,0-27.67,12.382-27.67,27.662v3.176v21.348v3.177C128.237,97.748,140.626,110.129,155.907,110.129z M220.41,16.265 c7.481,0,13.549,6.068,13.549,13.548c0,7.489-6.068,13.557-13.549,13.557c-7.497,0-13.565-6.068-13.565-13.557 C206.845,22.332,212.912,16.265,220.41,16.265z",
    style: {
      fill: "rgb(17, 104, 173)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M480.09,160.996c0.08,0.072,0.128,0.159,0.191,0.238c0.063,0.055,0.143,0.095,0.19,0.15L480.09,160.996z",
    style: {
      fill: "rgb(17, 104, 173)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M480.282,161.235c-8.927-8.752-23.254-8.72-32.116,0.15l-20.331,20.331l31.926,31.926l20.331-20.331 C488.938,184.456,488.986,170.161,480.282,161.235z",
    style: {
      fill: "rgb(17, 104, 173)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280.878,401.966l69.285-69.276l-41.377-41.377l-69.284,69.292c-4.146,4.153-4.146,10.904,0,15.065 l26.303,26.295C269.966,406.128,276.717,406.128,280.878,401.966z",
    style: {
      fill: "rgb(17, 104, 173)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "218.122,417.81 208.529,427.42 214.056,432.956 223.666,423.354 264.852,409.868 231.607,376.632  ",
    style: {
      fill: "rgb(17, 104, 173)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M383.058,100.782v93.276l32.53-32.53v-58.84c0-25.462-20.649-46.103-46.11-46.103h-40.647v25.882 c0,3.113-0.333,6.155-0.953,9.094h45.951C378.928,91.561,383.058,95.691,383.058,100.782z",
    style: {
      fill: "rgb(17, 104, 173)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M383.058,457.241c0,5.091-4.13,9.22-9.229,9.22H66.974c-5.083,0-9.212-4.13-9.212-9.22v-356.46 c0-5.091,4.13-9.22,9.212-9.22h45.968c-0.62-2.938-0.969-5.981-0.969-9.094V56.585H71.326c-25.462,0-46.094,20.641-46.094,46.103 v363.21c0,25.461,20.633,46.102,46.094,46.102h298.151c25.461,0,46.11-20.641,46.11-46.102V290.257l-32.53,32.53V457.241z",
    style: {
      fill: "rgb(17, 104, 173)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M316.172,283.928l41.377,41.369l100.94-100.948l-41.361-41.361L316.172,283.928z M426.976,214.492 c3.574,3.566,3.574,9.364,0,12.929l-49.112,49.12c-3.573,3.566-9.356,3.566-12.929,0c-3.574-3.566-3.574-9.364,0-12.93 l49.128-49.12C417.62,210.926,423.418,210.926,426.976,214.492z",
    style: {
      fill: "rgb(17, 104, 173)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "93.086,182.454 125.744,215.127 137.624,203.247 170.297,170.574 158.416,158.701 125.744,191.366  104.968,170.574  ",
    style: {
      fill: "rgb(17, 104, 173)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "158.416,244.091 125.744,276.756 104.968,255.964 93.086,267.845 125.744,300.518 137.624,288.637  170.297,255.964  ",
    style: {
      fill: "rgb(17, 104, 173)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "104.968,341.354 93.086,353.235 125.744,385.908 137.624,374.027 170.297,341.354 158.416,329.481  125.744,362.146  ",
    style: {
      fill: "rgb(17, 104, 173)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/Chart.113cf47a63a5295852553d30837350c2.svg";
export { ForwardRef as ReactComponent };